import GTM from "../../util/tracking/gtm";
import { EventCategory } from "../../util/tracking/types";
import { mapYesNoDecisionToEvent } from "../../util/tracking/eventActionMapper";
import React from "react";
import RadioButtonContainer from "../../ui/layout/page/forms-container/form-item-container/radio-button-container/input-container";
import OnboardingRadioButton from "../shared/components/formik/radiobutton";
import { useMessageSource } from "react-message-source";
import CustomTypography from "../../ui/widgets/typography";
import { YesNo } from "../general-company-information/types.tsx";

export const CashOnCard = (): React.JSX.Element => {
  const { getMessage } = useMessageSource();

  return (
    <div className="scd-section-helper-lg">
      <CustomTypography variant="h4" className="scd-container-base-small">
        {getMessage("AdditionalBenefits.cashOnCard-title")}
      </CustomTypography>
      <RadioButtonContainer>
        <OnboardingRadioButton
          wrap={false}
          title={getMessage("AdditionalBenefits.cashOnCard")}
          id="hasCashOnCard"
          name="hasCashOnCard"
          values={[
            {
              id: "cash-on-card-no",
              value: YesNo.NO,
              label: getMessage("YesNo.NO"),
            },
            {
              id: "cash-on-card-yes",
              value: YesNo.YES,
              label: getMessage("YesNo.YES"),
            },
          ]}
          onChangeCallback={(_, newValue) => {
            GTM.trackEvent(
              EventCategory.CashWithdrawal,
              mapYesNoDecisionToEvent(newValue),
            );
          }}
        />
      </RadioButtonContainer>
    </div>
  );
};
